import React from "react";
import { useGetTeamQuery } from "../../features/team/teamApi";

const Teams = () => {
  const { data: team } = useGetTeamQuery();
  return (
    <div className="mt-8">
      <h3 className="text-xl font-bold">Team Members</h3>
      <div className="mt-3 space-y-4">
        {team?.map((member) => (
          <div key={member.id} className="checkbox-container">
            <img
              src={member.avatar}
              className="team-avater"
              alt="Team member"
            />
            <p className="label">{member.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Teams;
